import { createPlacementFrontend } from '../frontend/create-placement-frontend';

import { createPlacementBackend } from './backend-factory';
import type {
	AnyProps,
	NoProps,
	PlacementMessageFrontendFactory,
	PlacementRenderer,
} from './frontend-types';
import type {
	AnyPlacementDefinition,
	DefaultPlacementDefinition,
	PlacementBackend,
	PlacementBackendFactory,
	PlacementMessageBackendFactory,
} from './backend-types';
import type { PlacementConfig } from './shared-types';

export const createPlacement = <T extends AnyPlacementDefinition = DefaultPlacementDefinition>(
	placementConfig: PlacementConfig,
): {
	createFrontend: <U extends AnyProps = NoProps>(
		placementRenderer: PlacementRenderer<T['frontend'], U>,
	) => PlacementMessageFrontendFactory<T['frontend'], U>;
	createBackend: (
		placementBackendParams?: PlacementBackend<T['backend']> | undefined,
	) => PlacementMessageBackendFactory<T['backend']>;
} => {
	return {
		createFrontend: createPlacementFrontend<T['frontend']>(placementConfig),
		createBackend: createPlacementBackend<T['backend']>(placementConfig),
	};
};

export {
	createBackendPlacementMessageTemplateRouter,
	createBackendPlacementRunners,
	createPlacementBackend,
	createPlacementMessageBackend,
} from './backend-factory';

export type { PlacementBackendFactory };
